import { render, staticRenderFns } from "./ReSearchCardStaff.vue?vue&type=template&id=6f81318e&scoped=true"
import script from "./ReSearchCardStaff.vue?vue&type=script&lang=js"
export * from "./ReSearchCardStaff.vue?vue&type=script&lang=js"
import style0 from "./ReSearchCardStaff.vue?vue&type=style&index=0&id=6f81318e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f81318e",
  null
  
)

export default component.exports